export default __webpack_public_path__ + "static/media/9.cd2886fb.jpg";